module.exports = require('./helpers/bundle-url').getBundleURL('8aiQJ') + "trailbluvideo.34f4d9e4.mp4";